import {CircularProgressProps} from './circular-progress-types'
import {Container, TimeDisplay, SVGComponent} from './style-component'
import { useTheme } from "@/contexts/theme-context/useThemeContext";

const CircularProgress: React.FC<CircularProgressProps> = ({
  periodicIntervalInSeconds,
  remainingTime
}) => {

  const { theme } = useTheme();

  const formatWithLeadingZero = (num: number): string => {
    return num < 10 ? `0${num}` : num.toString();
  };

  const formattedTime = () => {
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    return `${formatWithLeadingZero(minutes)}:${formatWithLeadingZero(seconds)}`;
  };

  const progressOffset = (progressValue: number) => {
    return 43.98 * (1 - progressValue / 100);
  };

  const progressValue = (remainingTime / periodicIntervalInSeconds) * 100;

  return (
    <Container>
      {remainingTime !== 0 && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TimeDisplay data-testid="time-display">Este código se actualizará en: </TimeDisplay>
          <SVGComponent>
            <circle
              cx="12"
              cy="12"
              r="7"
              stroke={theme.colors.text.neutral}
              strokeWidth="2"
              fill="none"
            />
            <circle
              cx="12"
              cy="12"
              r="7"
              stroke={theme.colors.theme.brandColor3}
              strokeWidth="2"
              fill="none"
              strokeDasharray="43.98"
              strokeDashoffset={progressOffset(progressValue)}
              transform="rotate(-90 12 12)"
            />
          </SVGComponent>
          {formattedTime()}
        </div>
      )}
    </Container>
  );
};

export default CircularProgress;
